import Enum from '/@/modules/core/app/helpers/Enum';

export class DocumentMetaType extends Enum {
  static DOCUMENT_OTHER_META = 'DocumentOtherMeta';

  static DOCUMENT_ADMINISTRATION_LETTER_META = 'DocumentAdministrationLetterMeta';

  static DOCUMENT_BANK_STATEMENT_META = 'DocumentBankStatementMeta';

  static DOCUMENT_CLOSING_LETTER_META = 'DocumentClosingLetterMeta';

  static DOCUMENT_DRIVERS_LICENSE_META = 'DocumentDriversLicenseMeta';

  static DOCUMENT_PASSPORT_META = 'DocumentPassportMeta';

  static DOCUMENT_GRANT_OF_PROBATE_META = 'DocumentGrantOfProbateMeta';

  static DOCUMENT_MARRIAGE_CONTRACT_META = 'DocumentMarriageContractMeta';

  static DOCUMENT_WILL_META = 'DocumentWillMeta';
}
